import { AutoScrollingCards } from '../../components/AutoScrollingCards';
import React from 'react';
import { CardRating } from './CardRating';
import { CardVideo } from './CardVideo';

export type TestimonialCarousselAutoProps = {
  cards: {
    type: 'rating' | 'video';
    rating: number;
    video?: string;
    name: string;
    picto: string;
    review: string;
  }[];
  inverse?: boolean;
};
export const TestimonialCarousselAuto = ({
  cards,
  inverse = true,
}: TestimonialCarousselAutoProps) => {
  return (
    <AutoScrollingCards
      inverse={inverse}
      gap={20}
      duration={(cards.length * 60000) / 5}
      className={'pb-[56px] -mb-[36px] pt-[10px] -mt-[10px]'}
    >
      {cards.map((card, key) => {
        if (card.type === 'rating') {
          return <CardRating key={key} {...card} className="md:h-[320px]" />;
        }
        if (card.type === 'video') {
          return <CardVideo key={key} {...card} />;
        }
        return <></>;
      })}
    </AutoScrollingCards>
  );
};
